var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analytics"},[_vm._v(" Analytics Screen"),_c('br'),_c('br'),_c('router-link',{attrs:{"tag":"div","to":{ name: 'Home' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var navigate = ref.navigate;
return [_c('ui-button',{attrs:{"button":"cta","icon":"world","label":"Go back home"},on:{"click":navigate}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }